package app.layouts

import kotlinx.html.js.onChangeFunction
import kotlinx.html.js.onClickFunction
import org.w3c.dom.get
import react.RBuilder
import react.RComponent
import react.RProps
import react.RState
import react.dom.div
import react.dom.h3
import react.dom.li
import react.dom.ul
import react.router.dom.navLink
import kotlin.browser.localStorage
import kotlin.browser.window

class AdminMenu : RComponent<RProps, RState>() {

    fun logout() {
        localStorage.removeItem("jwt")
        window.location.assign("/admin")
    }

    override fun RBuilder.render() {
        div("adminMenu") {
            div("adminMenuHeader") {
                h3 {
                    +"ADMIN"
                }
            }
            ul("menuList") {
                li("active") {
                    navLink("/dashboard") {
                        +"Հայտեր"
                    }
                }
                if(localStorage.get("type") == "0") {
                    li {
                        navLink("/emails") {
                            +"Էլ․ Փոստ"
                        }
                    }
                    li {
                        navLink("/creditType") {
                            +"Վարկի տեսակը"
                        }
                    }
                    li {
                        navLink("/currency") {
                            +"Արժույթ"
                        }
                    }
                    li {
                        navLink("/region") {
                            +"Մարզ"
                        }
                    }
                    li {
                        navLink("/guaranty") {
                            +"Վարկի ապահովություն"
                        }
                    }
                    li {
                        navLink("/user") {
                            +"Ադմիններ"
                        }
                    }
                }
                li {
                    attrs {
                        onClickFunction = {
                            logout()
                        }
                    }
                    +"Ելք"
                }
            }
        }
    }
}

fun RBuilder.adminMenu() = child(AdminMenu::class) {}